export default ({ booleanName, trueTypes, falseTypes }) => {
  const INITIAL_STATE = {
    [booleanName]: false
  };

  return (state = INITIAL_STATE, action) => {
    if(trueTypes.indexOf(action.type) >= 0) {
        return {
          [booleanName]: true
        };
    }

    if(falseTypes.indexOf(action.type) >= 0) {
        return {
          [booleanName]: false
        };
    }

        return state;
  };
};




/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/booleanMaker.js
 **/